import { render, staticRenderFns } from "./code-edit.vue?vue&type=template&id=1e578b3f&scoped=true"
import script from "./code-edit.vue?vue&type=script&lang=js"
export * from "./code-edit.vue?vue&type=script&lang=js"
import style0 from "./code-edit.vue?vue&type=style&index=0&id=1e578b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e578b3f",
  null
  
)

export default component.exports